export interface PresenceLink {
  label: string
  url: string
}

export interface PresenceGroup {
  id: string
  title: string
  note: string
  links: PresenceLink[]
}

export const presenceGroups: PresenceGroup[] = [
  {
    id: 'codigo',
    title: 'Código y desarrollo',
    note: 'Repos, sandboxes y publicación técnica',
    links: [
      { label: 'GitHub', url: 'https://github.com/SolarisPKN' },
      { label: 'GitLab', url: 'https://gitlab.com/SolarisPKN' },
      { label: 'Codeberg', url: 'https://codeberg.org/SolarisPKN' },
      { label: 'Gitea', url: 'https://gitea.com/SolarisPKN' },
      { label: 'Bitbucket', url: 'https://bitbucket.org/solarispkn/workspace/overview' },
      { label: 'GitFlic', url: 'https://gitflic.ru/user/solarispkn' },
      { label: 'Launchpad', url: 'https://launchpad.net/~solarispkn' },
      { label: 'SourceForge', url: 'https://sourceforge.net/u/solarispkn/profile/' },
      { label: 'StackBlitz', url: 'https://stackblitz.com/@SolarisPKN' },
      { label: 'CodeSandbox', url: 'https://codesandbox.io/u/SolarisPKN' },
      { label: 'CodePen', url: 'https://codepen.io/SolarisPKN' },
      { label: 'JSFiddle', url: 'https://jsfiddle.net/u/SolarisPKN' },
      { label: 'Dev.to', url: 'https://dev.to/solarispkn' },
      { label: 'Hashnode', url: 'https://hashnode.com/@solarispkn' },
      { label: 'Medium', url: 'https://medium.com/@SolarisPKN' },
      { label: 'daily.dev', url: 'https://daily.dev/solarispkn' },
      { label: 'Read the Docs', url: 'https://app.readthedocs.org/profiles/SolarisPKN/' },
      { label: 'Product Hunt', url: 'https://www.producthunt.com/@solarispkn' },
      { label: 'Indie Hackers', url: 'https://www.indiehackers.com/SolarisPKN' },
      { label: 'Peerlist', url: 'https://peerlist.io/solarispkn' },
      { label: 'Linear', url: 'https://linear.app/solarispkn/' },
      { label: 'Figma', url: 'https://www.figma.com/@SolarisPKN' },
      { label: 'v0', url: 'https://v0.app/@solarispkn' },
      { label: 'Lovable', url: 'https://lovable.dev/@solarispkn' },
      { label: 'Base44', url: 'https://app.base44.com/@solarispkn' },
      { label: 'Appsmith', url: 'https://solarispkn.appsmith.com' },
    ],
  },
  {
    id: 'infra',
    title: 'Infraestructura e IA',
    note: 'Cloud, contenedores, modelos y datos',
    links: [
      { label: 'Docker Hub', url: 'https://hub.docker.com/repositories/solarispkn' },
      { label: 'Vercel', url: 'https://vercel.com/solarispkn' },
      { label: 'Railway', url: 'https://railway.com/u/solarispkn' },
      { label: 'Hugging Face', url: 'https://huggingface.co/SolarisPKN' },
      { label: 'Replicate', url: 'https://replicate.com/solarispkn/' },
      { label: 'Kaggle', url: 'https://www.kaggle.com/solarispkn' },
      { label: 'Tableau Public', url: 'https://public.tableau.com/app/profile/solaris.pkn/vizzes' },
      { label: 'Civitai', url: 'https://civitai.com/user/SolarisPKN' },
      { label: 'Wokwi', url: 'https://wokwi.com/makers/solarispkn' },
      { label: 'Arduino Project Hub', url: 'https://projecthub.arduino.cc/pablokoutanya' },
      { label: 'Open Collective', url: 'https://opencollective.com/solarispkn' },
      { label: 'Matrix', url: 'https://matrix.to/#/@solarispkn:matrix.org' },
    ],
  },
  {
    id: 'video',
    title: 'Streaming y video',
    note: 'Donde se transmite y se publica el contenido',
    links: [
      { label: 'YouTube', url: 'https://youtube.com/@SolarisPKN' },
      { label: 'Twitch', url: 'https://twitch.tv/solarispkn' },
      { label: 'Kick', url: 'https://kick.com/Solarispkn' },
      { label: 'TikTok', url: 'https://tiktok.com/@solarispkn' },
      { label: 'Rumble', url: 'https://rumble.com/user/PabloKoutaNya' },
      { label: 'Dailymotion', url: 'https://www.dailymotion.com/user/SolarisPKN' },
      { label: 'Vimeo', url: 'https://vimeo.com/solarispkn' },
      { label: 'Nimo TV', url: 'https://www.nimo.tv/live/6943165843' },
      { label: 'SOOP Live', url: 'https://www.sooplive.com/station/pablokoutany' },
      { label: 'IMDb', url: 'https://www.imdb.com/es/user/p.2sdmbkk3deexakbdrhka4wdauu' },
    ],
  },
  {
    id: 'social',
    title: 'Redes y comunidad',
    note: 'Conversación pública y contacto directo',
    links: [
      { label: 'LinkedIn', url: 'https://linkedin.com/in/solarispkn' },
      { label: 'Discord', url: 'https://discord.gg/A9DW7S7Kaz' },
      { label: 'X', url: 'https://x.com/SolarisPKN' },
      { label: 'Instagram', url: 'https://instagram.com/solarispkn' },
      { label: 'Facebook', url: 'https://facebook.com/solarispkn' },
      { label: 'Threads', url: 'https://www.threads.com/@solarispkn' },
      { label: 'Bluesky', url: 'https://bsky.app/profile/solarispkn.com.ar' },
      { label: 'Mastodon', url: 'https://mastodon.social/@SolarisPKN' },
      { label: 'Pixelfed', url: 'https://pixelfed.com/SolarisPKN' },
      { label: 'Reddit', url: 'https://www.reddit.com/user/TecnOtakus/' },
      { label: 'Tumblr', url: 'https://www.tumblr.com/solarispkn/' },
      { label: 'Pinterest', url: 'https://ar.pinterest.com/solarispkn/' },
      { label: 'Truth Social', url: 'https://truthsocial.com/@SolarisPKN' },
      { label: 'Flickr', url: 'https://www.flickr.com/people/204857773@N06/' },
      { label: 'Blogger', url: 'https://www.blogger.com/profile/01814088620497240673' },
      { label: 'Goodreads', url: 'https://goodreads.com/solarispkn/' },
      { label: 'Gravatar', url: 'https://gravatar.com/solarispkn' },
      { label: 'Linktree', url: 'https://linktr.ee/SolarisPKN' },
    ],
  },
  {
    id: 'gaming',
    title: 'Gaming y mods',
    note: 'Modpacks, servidores y plataformas de juego',
    links: [
      { label: 'CurseForge', url: 'https://www.curseforge.com/members/solarispkn/projects' },
      { label: 'Modrinth', url: 'https://modrinth.com/user/SolarisPKN' },
      { label: 'Nexus Mods', url: 'https://www.nexusmods.com/profile/SolarisPKN' },
      { label: 'SpigotMC', url: 'https://www.spigotmc.org/members/pablokoutanya.128496/' },
      { label: 'BuiltByBit', url: 'https://builtbybit.com/members/solarispkn.890582/' },
      { label: 'Planet Minecraft', url: 'https://www.planetminecraft.com/member/solarispkn/' },
      { label: 'Sandbox Galaxy', url: 'https://www.sandboxgalaxy.com/member/solarispkn/' },
      { label: 'Steam', url: 'https://steamcommunity.com/id/pablokoutanya/' },
      { label: 'Xbox', url: 'https://www.xbox.com/es-MX/play/user/SolarisPKN' },
      { label: 'Roblox', url: 'https://www.roblox.com/es/users/5863697496/profile' },
      { label: 'itch.io', url: 'https://solarispkn.itch.io/' },
      { label: 'Newgrounds', url: 'https://solarispkn.newgrounds.com/' },
      { label: 'Epic Dev Community', url: 'https://dev.epicgames.com/community/profile/WmndD/SolarisPKN' },
    ],
  },
  {
    id: 'arte',
    title: 'Diseño y arte',
    note: 'Trabajo visual, 3D y publicación creativa',
    links: [
      { label: 'ArtStation', url: 'https://www.artstation.com/solarispkn' },
      { label: 'DeviantArt', url: 'https://www.deviantart.com/pablokoutanya' },
      { label: 'Dribbble', url: 'https://dribbble.com/SolarisPKN' },
      { label: 'Sketchfab', url: 'https://sketchfab.com/SolarisPKN' },
      { label: 'Pixiv', url: 'https://www.pixiv.net/en/users/62481761' },
      { label: 'VGen', url: 'https://vgen.co/SolarisPKN' },
      { label: 'Tapas', url: 'https://tapas.io/SolarisPKN' },
    ],
  },
  {
    id: 'trabajo',
    title: 'Trabajo y apoyo',
    note: 'Encargos, freelance y formas de bancar el lab',
    links: [
      { label: 'Workana', url: 'https://www.workana.com/freelancer/69639f3a7401c8ef1bdd82572b8a51ba' },
      { label: 'Upwork', url: 'https://www.upwork.com/freelancers/~012a19a4f28dd326c5' },
      { label: 'Fiverr', url: 'https://www.fiverr.com/sellers/pablokoutanya' },
      { label: 'Freelancer', url: 'https://www.freelancer.es/u/PabloKoutaNya' },
      { label: 'CGHero', url: 'https://app.cghero.com/hire/SolarisPKN' },
      { label: 'Devoted Fusion', url: 'https://app.devotedfusion.com/u/solarisp5958' },
      { label: 'ADPList', url: 'https://adplist.org/members/user-87709d-msghljzd' },
      { label: 'Calendly', url: 'https://calendly.com/solarispkn' },
      { label: 'Patreon', url: 'https://www.patreon.com/cw/SolarisPKN' },
      { label: 'Ko-fi', url: 'https://ko-fi.com/solarispkn' },
      { label: 'Cafecito', url: 'https://cafecito.app/solarispkn' },
      { label: 'Gumroad', url: 'https://solarispkn.gumroad.com/' },
      { label: 'Etsy', url: 'https://www.etsy.com/es/people/0w8wiyoqp0da4tra' },
      { label: 'eBay', url: 'https://www.ebay.com/usr/solarispkn' },
      { label: 'Spotify', url: 'https://open.spotify.com/user/21hdk3nngnrfze7epsc6lbz6i' },
    ],
  },
  {
    id: 'formacion',
    title: 'Formación y credenciales',
    note: 'Certificaciones y perfil académico verificable',
    links: [
      { label: 'ORCID', url: 'https://orcid.org/0009-0008-3003-1736' },
      { label: 'Microsoft Learn', url: 'https://learn.microsoft.com/es-mx/users/solarispkn/' },
      { label: 'freeCodeCamp', url: 'https://www.freecodecamp.org/solarispkn' },
      { label: 'edX', url: 'https://profile.edx.org/u/SolarisPKN' },
      { label: 'Udemy', url: 'https://www.udemy.com/user/pablokoutanya/' },
      { label: 'Salesforce Trailblazer', url: 'https://www.salesforce.com/trailblazer/solarispkn' },
      { label: 'LeetCode', url: 'https://leetcode.com/u/SolarisPKN/' },
      { label: 'Codeforces', url: 'https://codeforces.com/profile/SolarisPKN' },
    ],
  },
]

export const totalProfiles = presenceGroups.reduce((n, g) => n + g.links.length, 0)
